var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.facility=='app')?_c('div',{staticClass:"app"}):_c('div',{staticClass:"pc_exhibitor"},[_c('Zs')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }